import M$plugin$CompleteTOC from './/facade/js/completetoc';
import M$control$CompleteTOCControl from './/facade/js/completetoccontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
window.M.plugin.CompleteTOC = M$plugin$CompleteTOC;
window.M.control.CompleteTOCControl = M$control$CompleteTOCControl;
